/* istanbul ignore file */
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import React from 'react';
import ExpenseTypeDropdown from 'domain/finance/expenses/shared/input/ExpenseTypeDropdown';

const ExpenseTypeFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <ExpenseTypeDropdown source={source} />
    </DropDownFilter>
  );
};

export default ExpenseTypeFilter;
